import React, { FC } from 'react'
import { PropertyKeyAccessType, PropertyKeyModel } from '@/models/property-keys'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';

interface Props {
    readonly propertyKeys: PropertyKeyModel[];
}

const useStyles = makeStyles(() => ({
    root: {
        maxWidth: '600px',
    },
}));

const PropertyKeysTable: FC<Props> = ({ propertyKeys  }) => {
    const classes = useStyles();

    function getCodeValue(propertyKey: PropertyKeyModel): string {

        if (propertyKey.accessType === PropertyKeyAccessType.Code) {
            return propertyKey.code ?? 'To see the code, try refreshing the page in 5 seconds.'
        }

        if (propertyKey.accessType === PropertyKeyAccessType.Remote) {
            return 'Remote opening'
        }

        if (propertyKey.accessType === PropertyKeyAccessType.Physical) {
            return 'Physical key'
        }

        return '-'
    }

    return (
        <div className={classes.root}>
            <TableContainer component={Paper}>
                <Table data-name="property-keys" stickyHeader aria-label="table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Door</TableCell>
                            <TableCell>Guest's code</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { propertyKeys?.map(propertyKey => (
                            <TableRow hover key={ propertyKey.id }>
                                <TableCell>{ propertyKey.name }</TableCell>
                                <TableCell>{ getCodeValue(propertyKey) }</TableCell>
                            </TableRow>
                        )) }
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default PropertyKeysTable

